<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="29.5" height="12.363" viewBox="0 0 29.5 12.363">
		<g transform="translate(-920.695 -523.238)">
			<g transform="translate(932.592 527.408)">
				<path d="M972.185,534.44h-1.87v6.06h4.071v-1.7h-2.2Z" transform="translate(-963.509 -534.388)" fill="#000"></path>
				<path
					d="M987.521,534.507l-1.361,2.028-1.362-2.027s-1.029-.014-1.611-.014l2.092,3.648v2.386h1.76v-2.386l2.092-3.648C988.55,534.493,987.521,534.507,987.521,534.507Z"
					transform="translate(-971.529 -534.421)"
					fill="#000"
				></path>
				<path
					d="M957.541,536.737h0a2.445,2.445,0,0,0-2.412-2.435h-2.87v6.111h1.779v-1.238h1.093a2.446,2.446,0,0,0,2.412-2.435h0v0Zm-1.606.2a.565.565,0,0,1-.5.622.617.617,0,0,1-.088,0h-1.307v-1.536h1.307a.566.566,0,0,1,.592.537.619.619,0,0,1,0,.088Z"
					transform="translate(-952.258 -534.302)"
					fill="#000"
				></path>
			</g>
			<g transform="translate(920.695 523.238)">
				<path
					d="M925.663,532.229v-5.577a3.413,3.413,0,0,1,3.413-3.414h.292a3.413,3.413,0,0,1,0,6.827h-1.1v2.164Z"
					transform="translate(-923.79 -523.238)"
					fill="#c458fb"
				></path>
				<g transform="translate(0 5.907)">
					<path
						d="M925.172,539.83v2.164h-2.6V538.91a3.411,3.411,0,0,0,1.54,6.456h.292a3.413,3.413,0,0,0,3.413-3.414h0V539.46a3.4,3.4,0,0,1-1.54.37Z"
						transform="translate(-920.695 -538.91)"
						fill="#1ccdfd"
					></path>
				</g>
				<path
					d="M928.3,532.184v2.165h-1.1a3.39,3.39,0,0,0-1.54.37V537.8h2.6v-2.164h1.1a3.4,3.4,0,0,0,1.54-.37v-3.085Z"
					transform="translate(-923.79 -528.812)"
					fill="#854cf9"
				></path>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'PlyLogoWithTextSVG',
};
</script>
